export class RentalFile {
  constructor(
    rental_file_technical_id,
    rental_file_boomerang_id,
    product_picture,
    rental_file_opened_since_days,
    rental_file_status,
    product_manufacturer_name,
    product_manufacturer_name_ref,
    product_category,
    product_sub_category,
    product_name,
    product_serial_number,
    client_name,
    client_email,
    client_phone,
    rental_file_package_boomerang_id,
    rental_client_cost,
    rental_distributor_cost,
    rental_file_additional_cost_boomerang_id,
    rental_client_additional_days_cost,
    rental_distributor_additional_days_cost,
    rental_deposit,
    rental_deposit_type,
    rentalCreatedDate
  ) {
    this.rental_file_technical_id = rental_file_technical_id
    this.rental_file_boomerang_id = rental_file_boomerang_id
    this.product_picture = product_picture
    this.rental_file_opened_since_days = rental_file_opened_since_days
    this.rental_file_status = rental_file_status
    this.product_manufacturer_name = product_manufacturer_name
    this.product_manufacturer_name_ref = product_manufacturer_name_ref
    this.product_category = product_category
    this.product_sub_category = product_sub_category
    this.product_name = product_name
    this.product_serial_number = product_serial_number
    this.client_name = client_name
    this.client_email = client_email
    this.client_phone = client_phone
    this.rental_file_package_boomerang_id = rental_file_package_boomerang_id
    this.rental_client_cost = rental_client_cost
    this.rental_distributor_cost = rental_distributor_cost
    this.rental_file_additional_cost_boomerang_id = rental_file_additional_cost_boomerang_id
    this.rental_client_additional_days_cost = rental_client_additional_days_cost
    this.rental_distributor_additional_days_cost = rental_distributor_additional_days_cost
    this.rental_deposit = rental_deposit
    this.rental_deposit_type = rental_deposit_type
    this.rentalCreatedDate = rentalCreatedDate
  }
}
